import { render, staticRenderFns } from "./PageForgotPassword.vue?vue&type=template&id=07d1b278"
import script from "./PageForgotPassword.vue?vue&type=script&lang=js"
export * from "./PageForgotPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07d1b278')) {
      api.createRecord('07d1b278', component.options)
    } else {
      api.reload('07d1b278', component.options)
    }
    module.hot.accept("./PageForgotPassword.vue?vue&type=template&id=07d1b278", function () {
      api.rerender('07d1b278', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/PageForgotPassword.vue"
export default component.exports